import {APPLY_TEAMMATES_FIELD} from '../actions';

const teamStepRef = {
  title: 'Please include the names and e-mails of your teammates below. They will receive an email with an invite to complete their registration. So, please let them know to be active.',
  description: '',
  field: 'teammates',
  type: 'emails',
  placeholder: 'Team Emails',
};

const initialState = {
  showPopup: false,
  currentStep: 1,
  currentSubstep: 1,
  steps: [
    {
      title: 'Choose Hackathon',
      index: 1,
      substeps: [
        {
          title: 'Which adidas Hackathon would you like to attend? *',
          description: 'We have the opportunity to meet each other in 4 amazing cities. Tell us which one suits you best.',
          field: 'location',
          type: 'select',
          options: [
            'Barcelona -14.04.2018-15.04.2018',
            'Sofia – 12.05.2018 -13.05.2018',
            'Madrid -26.05.2018 -27.05.2018',
            'Amsterdam – 09.06.2018-10.06.2018',
          ],
          placeholder: 'Location',
          validation: {
            type: 'block',
            items: [0, 1, 2, 3]
          },
          required: true,
        },
      ],
    },
    {
      title: 'Introduce yourself',
      index: 2,
      substeps: [
        {
          title: 'We’d like to get to know you better. Please enter your full name. *',
          description: '',
          field: 'name',
          type: 'name',
          placeholder: 'Name',
          validation: /[Mr|Mrs|Ms]+\s[a-zA-Z']{2,}\s[a-zA-Z]{2,}/,
          error: 'Please provide two names',
          required: true,
        },
        {
          title: 'Through which e-mail address can we reach you? *',
          description: 'We’ll use it to send you important information about the hackathon so you are fully prepared to compete!',
          field: 'email',
          type: 'free-text',
          placeholder: 'Email',
          validation: /\S+@\S+\.\S+/,
          error: 'Please provida a valid email address.',
          required: true,
        },
        {
          title: 'Please give us your telephone number including your country code. (e.g. 0034 for Spain) *',
          description: 'We need it for organizational purposes or in case of urgent changes.',
          field: 'phone',
          type: 'free-text',
          placeholder: 'Phone',
          validation: /(\+|[0]{2}){1}(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/,
          error: 'Please provida a phone number.',
          required: true,
        },
        {
          title: 'How old will you be on the day of the hackathon? *',
          description: 'Because of youth protection regulations, only people who are 18 years or older are allowed to attend the events.',
          field: 'age',
          type: 'select',
          options: ['18+', '17 or under'],
          validation: {
            type: 'exact',
            value: 0
          },
          required: true,
        },
        {
          title: 'Here is your chance to get connected with us via LinkedIn, Stackoverflow, Github and/or add your own website:',
          field: 'social_accounts',
          type: 'accounts', // TODO:: Add new features to the custom component
        },
      ],
    },
    {
      title: 'Share skills/role',
      index: 3,
      substeps: [
        {
          title: 'What role (s) would you like to play in your team during the hackathon? *',
          description: '',
          field: 'skill',
          type: 'multiselect',
          options: [
            'Back-end developer',
            'Front-end developer',
            'Full-stack developer',
            'Mobile Developer',
            'Data scientist',
            'Designer',
            'Innovator',
            'Presenter',
          ],
          required: true,
        },
        {
          title: 'What is your current occupation? *',
          description: '',
          field: 'occupation',
          type: 'select',
          options: [
            'Student',
            'Employee',
            'Full-stack developer',
            'Entrepreneur',
            'Other',
          ],
          required: true,
        },
        {
          title: 'Please list your skills that will help you the most during the hackathon. *',
          description: 'This will increase your chance of getting a spot in the event (since space is limited)',
          field: 'my_skills',
          type: 'free-text',
          placeholder: '',
          validation: /(\w)+/,
          error: 'Please provida a valid email address.',
          required: true,
        },
      ],
    },
    {
      title: 'Invite your team',
      index: 4,
      substeps: [
        {
          title: 'If you are applying as a team, please include the name of your team',
          description: '',
          field: 'team_name',
          type: 'free-text',
          placeholder: '',
          skip_next_if_empty: true
        },
        // {
        //   title: 'Please include the names and e-mails of your teammates below. In every team should have at least 1 person who have development skills.',
        //   description: '',
        //   field: 'teammates',
        //   type: 'emails',
        //   placeholder: 'Team Emails',
        // },
      ],
    },
    {
      title: 'And last details',
      index: 5,
      substeps: [
        {
          title: 'What is your t-shirt size? *',
          description: 'Every accepted participant will receive an exclusive adidas t-shirt.',
          field: 't_shirt_size',
          type: 'select',
          options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
          required: true,
        },
        {
          title: 'Do you have any dietary requirements?',
          description: 'During the event, we’ll provide you with delicious food options.',
          field: 'food_type',
          type: 'select',
          options: ['NOPE!', 'Vegetarian', 'Vegan', 'Gluten free', 'Other']
        },
        {
          title: 'How did you hear about adidas Hackathons? *',
          field: 'hear_from',
          type: 'select',
          options: ['Social media', 'adidas channels', 'Universities', 'Friends', 'Others'],
          required: true,
        },
        {
          title: 'Do you want to share something else with us?',
          field: 'share_with_us',
          type: 'free-text',
          placeholder: '',
        },
        {
          title: 'Amazing! In case you win the hackathon in your chosen city, would you be available to travel to adidas Headquarter in Germany for the finals on 2nd & 3rd July 2018? *',
          field: 'available_to_travel',
          type: 'select',
          options: ['Yes', 'No'],
          required: true,
        },
        {
          title: 'Do you agree to our <a target="_blank" href="/adidas-terms_conditions-apply.pdf">Terms & Conditions</a>? *',
          field: 'toc',
          type: 'select',
          options: ['Yes', 'No'],
          validation: {
            type: 'exact',
            value: 0
          },
          required: true,
        },
      ],
    },
  ]
}

const switchStepsForward = (state) => {
  let tempStep = state.currentStep;
  let tempSubstep = state.currentSubstep;
  if((state.steps.length === state.currentStep) && (state.steps[tempStep - 1].substeps.length === tempSubstep)){
    return {};
  }
  if(state.steps[tempStep - 1].substeps.length === tempSubstep){
    return {
      currentStep: tempStep + 1,
      currentSubstep: 1
    }
  }
  return {
    currentStep: tempStep,
    currentSubstep: tempSubstep + 1
  }
}

const switchStepsBack = (state) => {
  let tempStep = state.currentStep;
  let tempSubstep = state.currentSubstep;
  if(tempSubstep === 1){
    return {
      currentStep: tempStep - 1,
      currentSubstep: state.steps[tempStep - 2].substeps.length
    }
  }
  return {
    currentStep: tempStep,
    currentSubstep: tempSubstep - 1
  }
}

const switchTeammatesField = (state, applyField) => {
  let tempSteps = state.steps.slice(0);
  let teammatesStep = tempSteps.filter((step) => {
    return step.index === 4
  })[0];
  if(applyField){
    if(teammatesStep.substeps.indexOf(teamStepRef) < 0){
      teammatesStep.substeps.push(teamStepRef);
    }
  }else{
    if(teammatesStep.substeps.indexOf(teamStepRef) !== -1){
      teammatesStep.substeps.splice(teammatesStep.substeps.indexOf(teamStepRef), 1);
    }
  }
  return tempSteps;
}


const removeTeamSteps = (state) => {
  let tempState = Object.assign({}, state);
  tempState.steps.splice(3,1);
  return tempState.steps;
};
const apply = (state = initialState , action) => {
  switch (action.type) {
    case 'SWITCH_APPLY_POPUP':
      return {
        ...state,
        showPopup: action.show
      }
    case 'APPLY_TEAM_ID':
      return {
        ...state,
        steps: removeTeamSteps(state)
      }
    case APPLY_TEAMMATES_FIELD:
      return {
        ...state,
        steps: switchTeammatesField(state, action.add)
      }
    case 'REMOVE_TEAMMATES_FIELD':
      return {
        ...state,
        steps: switchTeammatesField(state, false)
      }
    case 'NEXT_STEP_APPLY':
      return {
        ...state,
        ...switchStepsForward(state)
      }
    case 'PREV_STEP_APPLY':
      return {
        ...state,
        ...switchStepsBack(state)
      }
    default:
      return state
  }
}

export default apply;



// WEBPACK FOOTER //
// ./src/reducers/apply.js